import { requestBuilder } from '../../http/RequestBuilder';
import type { TaxDocument } from '../types/TaxDocument';

const useGetAllTaxDocuments = requestBuilder.query<
    TaxDocument[],
    { userId: string }
>({
    endpoint: ({ userId }) => `/api/bank-accounts/user/${userId}/tax-documents`,
    queryKey: ({ userId }) => `getAllTaxDocuments/${userId}/`,
});

export default useGetAllTaxDocuments;
